define('helpers/raven',['require','exports','module','env','raven','ravenNative','ravenJQuery'],function (require, exports, module) {
  "use strict";

  var Config = require("env");

  require("raven");
  require("ravenNative");
  require("ravenJQuery");

  var ravenHelper = {
    init: function () {
      var settings = {
        tags: {
          env: Config.env,
        },
      };
      if (window.MD_TAG) {
        settings.release = MD_TAG;
      }
      settings.shouldSendCallback = function (data) {
        // avoid bootstrapvalidator problems
        return data && data.culprit && !data.culprit.bv;
      };
      Config.env !== "development" &&
        Raven.config(
          "https://71739e74216141599bb9b81b294e38d7@app.getsentry.com/58783",
          settings
        ).install();
    },
    setUserContext: function (me) {
      Config.env !== "development" &&
        Raven.setUserContext({
          email: me.getUID(),
          role: me.getRole(),
          gid: me.getGroup(),
        });
    },
    captureMessage: function (msg, extra) {
      Config.env !== "development" &&
        Raven.captureMessage("[" + Config.env + "] " + msg, {
          extra: extra,
        });
    },
  };

  module.exports = ravenHelper;
});

